(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["widerruf-formular"] && !Shopify.designMode) return;
  try {
    
  // Team-Benachrichtigung laeuft ueber das native Shopify-Contact-Submit (kein
  // preventDefault bei gueltigem Formular). Die rechtlich-transaktionale Kundenmail
  // wird parallel ueber die Klaviyo Client-Events-API ausgeloest: per keepalive,
  // damit der Request den Seitenwechsel durch das native Submit ueberlebt.
  class WiderrufForm extends HTMLElement {
    constructor() {
      super();
      this.metric = this.dataset.metric || 'Widerruf eingereicht';
      this.klaviyoKey = this.dataset.klaviyoKey || '';
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      // Nach erfolgreichem (nativem) Submit rendert Shopify die Erfolgsmeldung serverseitig.
      this.successEl = this.querySelector('.widerruf-success');
      if (this.successEl) {
        if (this.successEl.focus) this.successEl.focus();
        this.successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      if (!this.form) return;
      this.orderField = this.form.querySelector('[name="contact[Bestellnummer]"]');
      if (this.orderField) {
        // Leniente Format-Pruefung (kein Existenz-Check, nur Form: # + 3-6 Ziffern).
        this.orderField.addEventListener('input', () => this.validateOrder(false));
        this.orderField.addEventListener('blur', () => this.validateOrder(true));
      }
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    validateOrder(normalize) {
      const el = this.orderField;
      if (!el) return true;
      let v = el.value.trim().replace(/\s+/g, '');
      if (normalize && v && /^\d+$/.test(v)) {
        v = '#' + v; // fuehrende Raute ergaenzen
        el.value = v;
      }
      const ok = v === '' || /^#?\d{3,6}$/.test(v);
      el.setCustomValidity(ok ? '' : 'Bitte gib deine Bestellnummer wie in der Bestätigung an, zum Beispiel #8321.');
      return ok;
    }

    onSubmit(event) {
      // Das submit-Event feuert nur, wenn die Browser-Constraint-Validation bestanden ist.
      this.validateOrder(true);
      if (!this.form.checkValidity()) {
        event.preventDefault();
        this.form.reportValidity();
        return;
      }
      // Kundenbestaetigung via Klaviyo feuern (keepalive ueberlebt die Navigation),
      // dann natives Submit zu Shopify /contact zulassen (Team-Benachrichtigung).
      this.sendEvent(this.collect());
      const button = this.form.querySelector('button[type="submit"]');
      if (button) {
        button.disabled = true;
        button.textContent = 'Wird gesendet …';
      }
      // KEIN preventDefault -> natives Shopify-Contact-Submit laeuft weiter.
    }

    collect() {
      const val = (sel) => {
        const el = this.form.querySelector(sel);
        return el ? el.value.trim() : '';
      };
      const now = new Date();
      return {
        email: val('[name="contact[email]"]'),
        name: val('[name="contact[Name]"]'),
        order: val('[name="contact[Bestellnummer]"]'),
        reason: val('[name="contact[Widerrufsgrund (freiwillig)]"]'),
        time: now.toISOString(),
        readable: this.formatStamp(now)
      };
    }

    formatStamp(d) {
      const pad = (n) => String(n).padStart(2, '0');
      return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear() +
        ' um ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ' Uhr';
    }

    sendEvent(data) {
      // Nur die consent-freie Client-Events-API (keepalive). Kein Onsite-Fallback,
      // um bei nicht eindeutigem Erfolg kein Doppel-Event (Doppelmail) zu riskieren.
      if (!this.klaviyoKey || !data.email) return;
      const payload = {
        data: {
          type: 'event',
          attributes: {
            metric: { data: { type: 'metric', attributes: { name: this.metric } } },
            profile: { data: { type: 'profile', attributes: { email: data.email } } },
            properties: {
              Bestellnummer: data.order,
              Name: data.name,
              'Widerrufsgrund': data.reason,
              Eingang: data.time,
              'Eingang_lesbar': data.readable
            },
            time: data.time
          }
        }
      };
      try {
        fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(this.klaviyoKey), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          keepalive: true,
          body: JSON.stringify(payload)
        });
      } catch (e) { /* best effort, blockiert das native Submit nicht */ }
    }
  }

  if (!customElements.get('widerruf-form')) {
    customElements.define('widerruf-form', WiderrufForm);
  }

  } catch(e) { console.error(e); }
})();
})();
